export * from "-!../../../../../node_modules/cache-loader/dist/cjs.js!../../../../../node_modules/buble-loader/index.js??ref--2-1!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??ref--2!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./ResearchSearch.vue?vue&type=template&id=6f1eb178"


//////////////////
// WEBPACK FOOTER
// ./scripts/vue/components/ResearchSearch.vue?vue&type=template&id=6f1eb178
// module id = 419
// module chunks = 0